// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./Common.css";
// import ProductCard from "../../components/card/ProductCard";
// export default function WinterSale() {
//   const [winterSaleProducts, setWinterSaleProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const fetchProducts = async () => {
//     try {
//       // Fetch Just In products (nightwear collection)
//       const justInResponse = await fetch(
//         "https://mamaandpeaches.com/collections/kids-nightwear/products.json"
//       );
//       const justInData = await justInResponse.json();

//       // Fetch Winter Sale products
//       const winterSaleResponse = await fetch(
//         "https://mamaandpeaches.com/collections/winter-drop/products.json"
//       );
//       const winterSaleData = await winterSaleResponse.json();

//       //   setJustInProducts(justInData.products.slice(0, 8) || []);
//       setWinterSaleProducts(winterSaleData.products.slice(0, 8) || []);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//       setLoading(false);
//     }
//   };
//   return (
//     <section className="product-section winter-sale-section">
//       <div className="container">
//         <div className="section-header">
//           <h2>Winter Sale</h2>
//           <Link to="/collections/winter-drop" className="view-all">
//             View all
//           </Link>
//         </div>

//         {loading ? (
//           <div className="product-grid">
//             <div className="loading-text">Loading products...</div>
//           </div>
//         ) : (
//           <div className="product-grid">
//             {winterSaleProducts.map((product) => (
//               <ProductCard key={product.id} product={product} />
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProductCardNew from "../../components/card/ProductCardNew";
import productService from "../../services/productService";
import { useApiEnhanced } from "../../hooks/useApiEnhanced";
import "./WinterSale.css";

export default function WinterSale({ onProductClick }) {
  const [winterSaleProducts, setWinterSaleProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch hot deal products using your API
  const { data: hotDealsResponse, loading: productsLoading } = useApiEnhanced(
    () =>
      productService.getProducts({
        page: 1,
        limit: 8,
        isHotDeal: "true",
        status: "Active",
      }),
    { immediate: true }
  );

  // Process hot deal products when data is loaded
  useEffect(() => {
    if (hotDealsResponse?.success && hotDealsResponse?.data) {
      setWinterSaleProducts(hotDealsResponse.data);
      setLoading(false);
    }
  }, [hotDealsResponse]);

  // Fallback: Set loading to false if API call completes
  useEffect(() => {
    if (!productsLoading) {
      setLoading(false);
    }
  }, [productsLoading]);

  return (
    <section className="product-section winter-sale-section">
      <div className="container">
        <div className="section-header winter-header">
          <div className="section-title-wrapper">
            <h2>Winter Sale</h2>
            {/* <span className="sale-badge">Hot Deals 🔥</span> */}
          </div>
          <Link
            to="/products?filter=hotdeal"
            className="view-all winter-view-all"
          >
            View all
          </Link>
        </div>

        {loading ? (
          <div className="product-grid">
            <div className="loading-spinner-container">
              <div className="loading-spinner winter-spinner"></div>
              <p className="loading-text">Loading winter sale products...</p>
            </div>
          </div>
        ) : winterSaleProducts.length > 0 ? (
          <div className="product-grid">
            {winterSaleProducts.map((product) => (
              <ProductCardNew
                key={product._id}
                product={product}
                onProductClick={onProductClick}
              />
            ))}
          </div>
        ) : (
          <div className="product-grid">
            <div className="no-products winter-no-products">
              <p>
                No winter sale products available at the moment. Check back
                soon!
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
